export default __webpack_public_path__ + "static/media/selecta_mobile.4de2f46b.jpg";